import { useEffect } from "react";
import Lenis from "lenis";
import "lenis/dist/lenis.css";
import "@/App.css";
import { Toaster } from "sonner";
import { LangProvider } from "@/lib/lang";
import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Stats } from "@/components/Stats";
import { Gallery } from "@/components/Gallery";
import { Plans } from "@/components/Plans";
import { Film } from "@/components/Film";
import { Company } from "@/components/Company";
import { Club } from "@/components/Club";
import { Partners } from "@/components/Partners";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { WhatsAppButton } from "@/components/WhatsAppButton";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.075, smoothWheel: true, wheelMultiplier: 0.9 });
    window.__lenis = lenis;
    let id = requestAnimationFrame(function raf(time) {
      lenis.raf(time);
      id = requestAnimationFrame(raf);
    });
    return () => {
      cancelAnimationFrame(id);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <LangProvider>
      <div className="App">
        <Nav />
        <main>
          <Hero />
          <Marquee />
          <Stats />
          <Gallery />
          <Plans />
          <Film />
          <Company />
          <Club />
          <Partners />
          <Contact />
        </main>
        <Footer />
        <WhatsAppButton />
        <Toaster position="bottom-center" toastOptions={{ style: { background: "#0C3440", color: "#FFFFFF", border: "1px solid #24505B", borderRadius: 16 } }} />
      </div>
    </LangProvider>
  );
}

export default App;
